import { html } from 'lit-html';
import { formatPrice } from '../price_util';
import { getAssetsUrlBase } from '../../../models/common/static_resource_util';

/**
 * 価格を返却します
 * @param salesPriceTaxInclude 販売価格（税込）
 * @param isVariation バリエーション商品かどうか
 * @param isMedical メディカル商品かどうか
 * @param isUserLogin ログインユーザーかどうか
 */
export const PriceArea = (
  salesPriceTaxInclude: string,
  isVariation: boolean,
  isMedical: boolean,
  isUserLogin: boolean
) => {
  const salesPriceTax = formatPrice(Number(salesPriceTaxInclude), isVariation);
  // 未ログインユーザーには、メディカル品の価格を表示してはいけない
  if (isMedical && !isUserLogin) return html``;
  if (salesPriceTaxInclude == "" || salesPriceTaxInclude == 'null') return html``;
  return html`
    <div class="m-simpleitemcard_price">
      <p class="a-price">
        <span class="a-price_value">${salesPriceTax}</span>
        <span class="a-price_after">（税込）</span>
      </p>
    </div>
  `;
};

/**
 * 価格を返却します（バリエーション画面のみ）
 * @param salesPriceTaxInclude 販売価格（税込）
 * @param isVariation バリエーション商品かどうか
 * @param isMedical メディカル商品かどうか
 * @param isUserLogin ログインユーザーかどうか
 */
export const PriceAreaWithButton = (
  salesPriceTaxInclude: string,
  isVariation: boolean,
  isMedical: boolean,
  isUserLogin: boolean
) => {
  const salesPriceTax = formatPrice(Number(salesPriceTaxInclude), isVariation);
  // 未ログインユーザーには、メディカル品の価格を表示してはいけない
  if (isMedical && !isUserLogin) return html``;
  if (salesPriceTaxInclude == "" || salesPriceTaxInclude == 'null') return html``;
  return html`
    <div class="m-itemcard_price">
      <p class="a-price">
        <span class="a-price_value">${salesPriceTax}</span>
        <span class="a-price_after">（税込）</span>
      </p>
    </div>
  `;
};

export const SmallPriceArea = (
  salesPriceTaxInclude: string,
  isVariation: boolean,
  isMedical: boolean,
  isUserLogin: boolean
) => {
  const salesPriceTax = formatPrice(Number(salesPriceTaxInclude), isVariation);
  // 未ログインユーザーには、メディカル品の価格を表示してはいけない
  if (isMedical && !isUserLogin) return html``;
  if (salesPriceTaxInclude == "" || salesPriceTaxInclude == 'null') return html``;
  return html`
    <div class="m-simpleitemcard_price">
      <p class="a-price -small">
        <span class="a-price_value">${salesPriceTax}</span>
        <span class="a-price_after">（税込）</span>
      </p>
    </div>
  `;
};

/**
 * 商品画像を返却します
 * 商品画像が設定されていない場合はNoPhoto画像を返却します
 * @param imageUrl
 */
export const ItemImage = (imageUrl: string, itemName: string) => {
  if (imageUrl) {
    return html`<img
      data-src="${imageUrl}"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN89h8AAtEB5wrzxXEAAAAASUVORK5CYII="
      class="a-img_img js-lazy-img"
      alt="${itemName}"
    />`;
  }
  return html`<img
    data-src="${getAssetsUrlBase() + "images/img_nophoto.jpg"}"
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN89h8AAtEB5wrzxXEAAAAASUVORK5CYII="
    class="a-img_img js-lazy-img"
    alt=""
  />`;
};

/**
 * 商品リンクを返却します
 * @param supplierId サプライヤID
 * @param itemCode カタログ商品コードやバリエーションコードが入る
 * @param isVariation バリエーションかどうか
 */
export const ItemLink = (supplierId: string, itemCode: string, isVariation: boolean, rrLinkUrl?: string) => {
  // RichRelevenceから返却されるURLがある場合はそちらを優先する
  if(rrLinkUrl) {
    return rrLinkUrl;
  }

  // バリエーション商品の場合
  if (isVariation) {
    return `/v/${variationCodeForLink(itemCode)}/`;
  }
  // 単品商品
  if (supplierId) {
    return supplierId === 'P00001' ? `/p/${itemCode}/` : `/p/${supplierId}-${itemCode}/`;
  }

  return `/p/${itemCode}/`;
};

const variationCodeForLink = (variationCode: string) => {
  if (variationCode.length < 6) {
    return variationCode
  }
  return zeroPadding(variationCode, 9);
}

const zeroPadding = (target: string, length: number) => {
  return ( Array(length).join('0') + target ).slice( -length );
}
